import React from "react"
import { getMapKey, getPaddingsClassFromData } from "@/utils/utils"
import Tab from "@/components/ExpandingTabs/Tab"
import styled from "styled-components"
import HeaderDescriptionBlock from "@/components/HeaderDescriptionBlock"

const Wrapper = styled.div`
	.text {
		p {
			img {
				max-width: 100%;
			}
		}
	}
`

const ExpandingTabs = ({ data }) => {
	const paddings = getPaddingsClassFromData(data)
	const source = data?.tabs || []
	const id = data?.id || ""
	const tabs = Array.isArray(source) ? source : []
	const headerDescription = data?.headerDescription || {}

	return (
		<Wrapper id={id} className={`${paddings}`}>
			{headerDescription?.header && <HeaderDescriptionBlock headerDescription={headerDescription} className="no-margin padding" />}
			{tabs.map((item, index) => (
				<Tab key={getMapKey(item, index)} data={item} count={index + 1} isLast={index + 1 === tabs.length} />
			))}
		</Wrapper>
	)
}

export default ExpandingTabs
